import React from 'react'
import { Modal, Button } from '@imedcl/design-system'
import { ReactComponent as ImagenMujer } from '../../assets/img/carga_nuevos_datos.svg'
import { useNavigate } from 'react-router-dom'

export default function ModalContent() {
  const navigate = useNavigate()

  const volver = () => {
    navigate('/')
  }
  return (
    <div className='mt-8'>
      <Modal backgroundClassName='!relative'>
        <React.Fragment key='.0'>
          <div className='mb-6  flex items-center justify-center '>
            <ImagenMujer></ImagenMujer>
          </div>
          <div>
            <h2 className='text-center text-xl text-secondary-imed-100 mb-4'>
              El Rut ingresado no tiene deuda
            </h2>
          </div>
          <div className='flex items-center justify-center'>
            <Button className='m-4' type='secondary' onClick={volver}>
              Volver
            </Button>
          </div>
        </React.Fragment>
      </Modal>
    </div>
  )
}
